import moneyFormat from '../functions/moneyFormat';
import { TableCell } from '@mui/material';

const MultipartWorkflowTableRow = ({ row, count, tableHeader,stickyEnabled }) => { 

    const getRowClassName = (columnOrder) =>{
        // Pass sticky row class if columnOrder is 0 i.e first column and stickyEnabled Prop is true
        return stickyEnabled && columnOrder===0 ? "table-cell-sticky-row": ""
    }

    return (
        <>
            {tableHeader.map(el =>
                el['columnname'] == 'grossspend' || el['columnname'] == 'grossinterchange' || el['columnname'] == 'incentiveamount' ? 
                    <TableCell className={getRowClassName(el['columnorder'])} align='right'>{moneyFormat(row[el['columnname']])}</TableCell>
                :<TableCell className={getRowClassName(el['columnorder'])}>{row[el['columnname']]}</TableCell>
            )}
        </> 
    );
}

export default MultipartWorkflowTableRow;